import { useCallback, useRef } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { rem } from 'polished'
import styled from 'styled-components'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import TextButton from 'LuxKit/Button/TextButton'
import { useCruiseDeals } from 'hooks/Cruise/useCruiseDeals'
import DealsTile from 'components/Common/DealsTile/DealsTile'
import * as Analytics from 'analytics/analytics'

const DealsHeaderGrid = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr max-content;
  grid-gap: ${rem(12)};

  ${mediaQueryUp.tablet} {
    grid-gap: ${rem(16)};
  }
`

function CruisePageDealsTileCarousel() {
  const intl = useIntl()
  const carouselRef = useRef<HTMLDivElement | null>(null)

  const { deals, isLoading } = useCruiseDeals()

  const onClickViewAll = useCallback(() => {
    Analytics.trackClientEvent({
      subject: 'cruises-deals-view-all',
      action: 'clicked',
      type: 'interaction',
      category: 'vertical_page',
    })
  }, [])

  const viewAllLabel = intl.formatMessage({
    id: 'dUG37uPm98Rdwpu9zPMC',
    defaultMessage: 'View all',
    description: 'Action button label to view all cruise deal promotions',
  })

  if (!isLoading && !deals.length) return null

  return <Group gap={32} direction="vertical">
    <LayoutContainer>
      <DealsHeaderGrid>
        <Heading variant="heading2">
          <FormattedMessage
            id="wtm0UXm0FyP3ga_tCufv"
            defaultMessage="Set sail with our hot cruise <i>promotions</i>"
            description="Section heading for cruise deal promotions carousel"
            values={{ i: (chunks) => <i>{chunks}</i> }}
          />
        </Heading>
        <TextButton kind="tertiary" to="/cruises/deals" onClick={onClickViewAll}>{viewAllLabel}</TextButton>
      </DealsHeaderGrid>
    </LayoutContainer>
    <DealsTile carouselRef={carouselRef} deals={deals} isLoading={isLoading} />
  </Group>
}

export default CruisePageDealsTileCarousel
